import { Button, Modal } from 'antd';
import React, { useState } from 'react';
import { TagsManagerPublisherDomain } from '../../../../../core/components/tags/manager/TagsManagerWrapper';
import { modal } from '../../../Tasks/configs/designTokens';
import '../../../Tags/styles/index.scss';

const CreatePublisherDomainTag = () => {
  const [visible, setVisible] = useState(false);
  return (
    <React.Fragment>
      <Modal
        visible={visible}
        footer={null}
        onCancel={() => {
          setVisible(false);
        }}
        title={'Create Publisher Domain Tags'}
        wrapClassName="tags-modal"
        width={modal.wide}
        centered
      >
        <TagsManagerPublisherDomain headerSubmit={false} onCard={false} onCancel={() => setVisible(false)} />
      </Modal>
      <Button
        shape="round"
        type="primary"
        onClick={() => {
          setVisible(!visible);
        }}
      >
        Create Publisher Domain Tags
      </Button>
    </React.Fragment>
  );
};

export default CreatePublisherDomainTag;
